import { useTrendingStocks } from '@/components/Search/hooks/useTrendingStocks';
import { NarrativeMiniValuatorHighlightedCompanyButton } from './NarrativeMiniValuatorHighlightedCompanyButton';

type Props = {
  onCompanySelect: (canonicalUrl: string) => void;
};

const TrendingStocksGridViewIdProd = 376743;
const TrendingStocksGridViewIdDev = 292980;

export const NarrativeMiniValuatorTrendingCompanies = ({
  onCompanySelect,
}: Props) => {
  const { data: trendingStocks = [], status: trendingStocksFetchStatus } =
    useTrendingStocks({
      gridViewId:
        SWS_ENV === 'prod' || SWS_ENV === 'staging'
          ? TrendingStocksGridViewIdProd
          : TrendingStocksGridViewIdDev,
      limit: 3,
    });

  if (trendingStocksFetchStatus === 'pending')
    return (
      <div className="grid gap-x1">
        {Array.from({ length: 3 }).map((_, index) => (
          <div
            key={index}
            className="grid grid-cols-[theme(spacing.x7)_1fr] grid-rows-[58px] gap-x1_5"
          >
            <div className="bones" />
            <div className="bones" />
          </div>
        ))}
      </div>
    );

  if (trendingStocksFetchStatus === 'error')
    return (
      <div className="text-xs text-softer">No popular companies found</div>
    );

  return (
    <div role="group" className="grid gap-x0_5">
      {trendingStocks.map((company) => (
        <NarrativeMiniValuatorHighlightedCompanyButton
          key={company.canonicalURL}
          canonicalUrl={company.canonicalURL}
          onCompanySelect={onCompanySelect}
          tickerSymbol={company.tickerSymbol}
          url={company.info.url}
          name={company.name}
          countryIso2={company.country.iso2}
        />
      ))}
    </div>
  );
};
